import axios from 'axios';
import { API_BASE_URL } from '../../config';

// Create a separate instance for LMS requests
const lmsApi = axios.create({
    baseURL: `${API_BASE_URL}/api/lms`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // Crucial for sending cookies
    xsrfCookieName: 'apicsrftoken',
    xsrfHeaderName: 'X-CSRFToken',
});

// Request Interceptor to add Token - REMOVED for HttpOnly Cookies
// Authorization is now handled by the browser via cookies
/*
lmsApi.interceptors.request.use(
    (config) => {
        // CSRF Token logic can be added here if needed
        // Since we are using HttpOnly cookies for sessions, we don't need to manually attach tokens
        // Just ensure withCredentials: true is set on axios instance (which it is)
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
*/

// Response Interceptor for handling 401 (Optional: Clear token)
lmsApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // localStorage.removeItem('lms_token');
            // window.location.href = '/lms/login'; 
            // Commented out to prevent loops, handle in UI
        }
        return Promise.reject(error);
    }
);

export default lmsApi;
